import { render, staticRenderFns } from "./ProjectLink.vue?vue&type=template&id=a4faddde&"
import script from "./ProjectLink.vue?vue&type=script&lang=js&"
export * from "./ProjectLink.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports